import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const KEY = "bc_wishlist";

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);

  useEffect(() => {
    if (user) {
      api.get("/wishlist").then((r) => setIds(r.data.map((p) => p.id))).catch(() => {});
    }
  }, [user]);

  const toggle = async (productId) => {
    if (user) {
      const { data } = await api.post("/wishlist/toggle", { product_id: productId });
      setIds(data.wishlist);
      toast.success(data.added ? "Saved to wishlist" : "Removed from wishlist");
    } else {
      setIds((prev) => {
        const has = prev.includes(productId);
        toast.success(has ? "Removed from wishlist" : "Saved to wishlist");
        return has ? prev.filter((x) => x !== productId) : [...prev, productId];
      });
    }
  };

  const has = (id) => ids.includes(id);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
